module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Preface#pref"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "loa"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Abbreviations#loabb"
    }
  }, [_c('i', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmts",
    attrs: {
      "id": "in"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#intr"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "ch01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#ch-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "cs"
  }, [_vm._v("From Inclusion to Exclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "ch02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#ch-02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "cs"
  }, [_vm._v("Not to Be Trusted")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "ch03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ch-03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "cs"
  }, [_vm._v("The Encyclopedia and “The Falsification of History”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "ch04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ch-04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "cs"
  }, [_vm._v("We, the Students")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "ch05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ch-05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "cs"
  }, [_vm._v("“To Warsaw Students”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "ch06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#ch-06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "cs"
  }, [_vm._v("“Zionism Is Not a Danger to Poland”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Conclusion#conc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmts",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 72
// module chunks = 0